import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import CheckboxOption from "../../common-filters-components/CheckboxOption";
import {
  isSelected,
  toggleOption,
} from "../../common-filters-components/toggleOption";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface props {
  setState: (state: any) => void;
  filter: IFilter;
  state: string[];
  unAvailabeKeys?: string[];
  outOfStockKeys?: string[];
  allow_user_request_stock_availability_reminder?: boolean;
}
const DropDownFilter: React.FC<props> = ({
  state,
  setState,
  filter,
  unAvailabeKeys = false,
  outOfStockKeys,
  allow_user_request_stock_availability_reminder,
}) => {
  const t = useTranslation();
  const options = filter?.data ?? [];
  const is_multi_select = filter?.configurations?.is_multi_select;
  const handleOption = (key: string) => {
    const currentSelected = toggleOption(state, key, is_multi_select);
    setState(currentSelected);
  };
  return (
    <OptionsDropdown
      title={
        state?.length > 0
          ? state
              ?.map(
                (id: string) =>
                  options[options.findIndex((o) => o.key === id)]?.value,
              )
              .join(", ")
          : t.choose_from_list
      }
    >
      {options
        .filter((op) => !isSelected(unAvailabeKeys, op.key))
        ?.map((op) => {
          const disabled = allow_user_request_stock_availability_reminder
            ? isSelected(unAvailabeKeys, op.key)
            : isSelected(unAvailabeKeys, op.key) ||
              isSelected(outOfStockKeys, op.key);
          const alloweSelectOutOfStock =
            allow_user_request_stock_availability_reminder
              ? isSelected(outOfStockKeys, op.key)
              : undefined;
          return (
            <CheckboxOption
              key={op.key}
              label={op.value}
              disabled={disabled}
              checked={isSelected(state, op.key)}
              toggleOption={() => handleOption(op.key)}
              is_multi_select={is_multi_select}
              alloweSelectOutOfStock={alloweSelectOutOfStock}
            />
          );
        })}
    </OptionsDropdown>
  );
};

export default DropDownFilter;
